/**
 * QR encoding contracts — Connect (dog-specific token) vs Invite (general referral).
 */

import { resolveWagamourInviteUrl, wagamourInviteUrlIsSafeForReferral } from '@/lib/play/wagamourInviteReferral'

export type ConnectQrContractDiagnostics = {
  dogSpecificQr: true
  tokenBacked: true
  expiresLabel: string | null
}

export function isConnectDogCardQrUrl(url: string): boolean {
  if (!url.trim()) return false
  try {
    const { pathname } = new URL(url, 'http://localhost')
    return /\/play\/connect\/[^/]+$/i.test(pathname)
  } catch {
    return /\/play\/connect\/[^/]+/i.test(url)
  }
}

export function isWagamourReferralQrUrl(url: string): boolean {
  return wagamourInviteUrlIsSafeForReferral(url) && !isConnectDogCardQrUrl(url)
}

export function assertInviteQrUrlContract(url: string): boolean {
  if (!isWagamourReferralQrUrl(url)) return false
  if (/dogId|userId|email|token|resumeRef|play\/connect/i.test(url)) return false
  return true
}

export function resolveInviteQrUrlForEnvironment(origin?: string | null): string {
  return resolveWagamourInviteUrl(origin)
}
